'use strict';

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Tracks = undefined;

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var guid = 0;

var Tracks = exports.Tracks = (function () {
  function Tracks(containerEl, panel, params) {
    _classCallCheck(this, Tracks);

    params = _jquery2.default.extend({
      classPrefix: 'tracklist',
      autoNextTrack: true,
      tracks: [] }, /* [ {title: 'Title', src: '/url', duration: 'MM:SS'}] */
    params);
    this._panel = panel;
    this._params = params;
    this._callbacks = {};
    var cssClass = {};
    var cssClassSub = {
      track: 'track',
      activeTrack: 'track-active',
      trackTitle: 'track-title',
      trackDuration: 'track-duration'
    };
    for (var subName in cssClassSub) {
      cssClass[subName] = params.classPrefix + '-' + cssClassSub[subName];
    }
    this._cssClass = cssClass;
    this._triggerObj = (0, _jquery2.default)(this);
    this.tracks = _jquery2.default.map(params.tracks, function (track, idx) {
      return _jquery2.default.extend(track, { idx: idx });
    });
    this.track = undefined;
    var $controls = this._createControls(params, cssClass, this.tracks);
    this._$trackItems = $controls.find('.' + cssClass.track);
    $controls.on('click', '.' + cssClass.track, this._onTrackClick.bind(this));
    (0, _jquery2.default)(containerEl).append($controls);
    panel.on('load', this._onPanelTrackLoad.bind(this));
    panel.on('end', this._onPanelTrackEnd.bind(this));
  }

  _createClass(Tracks, [{
    key: 'on',
    value: function on(eventName, callback) {
      var handler = function handler() {
        callback.apply(null, Array.prototype.slice.call(arguments, 1));
      };
      this._triggerObj.on(eventName, handler);
      if (typeof callback.audio_guid === "undefined") {
        callback.audio_guid = guid++;
      }
      this._callbacks[eventName + ':' + callback.audio_guid] = handler;
      return this;
    }
  }, {
    key: 'off',
    value: function off(eventName, callback) {
      var handler = this._callbacks[eventName + ':' + callback.audio_guid];
      if (handler) {
        delete this._callbacks[eventName + ':' + callback.audio_guid];
        this._triggerObj.off(eventName, handler);
      }
      return this;
    }
  }, {
    key: 'selectTrack',
    value: function selectTrack(idx) {
      this._selectActive(idx);
      this._panel.load(this.track);
      this._panel.play();
      this._triggerObj.triggerHandler('selectTrack', [this.track]);
      return this;
    }
  }, {
    key: '_onPanelTrackLoad',
    value: function _onPanelTrackLoad(track) {
      for (var i = 0; i < this.tracks.length; i++) {
        if (this.tracks[i].src === track.src) {
          this._selectActive(this.tracks[i].idx);
          break;
        }
      }
    }
  }, {
    key: '_onPanelTrackEnd',
    value: function _onPanelTrackEnd() {
      if (this._params.autoNextTrack) {
        if (this.track.idx < this.tracks.length - 1) {
          this.selectTrack(this.track.idx + 1);
        }
      }
    }
  }, {
    key: '_selectActive',
    value: function _selectActive(idx) {
      if (!this.track || this.track.idx !== idx) {
        this._$trackItems.removeClass(this._cssClass.activeTrack);
        this._$trackItems.eq(idx).addClass(this._cssClass.activeTrack);
        this.track = this.tracks[idx];
      }
    }
  }, {
    key: '_onTrackClick',
    value: function _onTrackClick(evt) {
      var trackEl = (0, _jquery2.default)(evt.currentTarget);
      var idx = trackEl.data('idx');
      this.selectTrack(idx);
    }
  }, {
    key: '_createControls',
    value: function _createControls(params, cssClass, tracks) {
      return (0, _jquery2.default)('<ul class="' + params.classPrefix + '">' + _jquery2.default.map(tracks, function (track, idx) {
        var $el = (0, _jquery2.default)('<li class="' + cssClass.track + '" data-idx="' + idx + '">' + '<div class="' + cssClass.trackTitle + '"></div>' + '<div class="' + cssClass.trackDuration + '">' + (track.duration || '') + '</div>' + '</li>');
        $el.find('.' + cssClass.trackTitle).attr('title', track.title).text(track.title);
        return $el[0].outerHTML;
      }).join('') + '</ul>');
    }
  }]);

  return Tracks;
})();